<template>
    <div class="card config-section">
        <CardHeader
            title="Parâmetros de Rodízio"
            icon="fas fa-sync-alt"
        />
        <div class="card-body">
            <div class="section-form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input
                                    id="select_caster"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :checked="value.select_caster"
                                    @change="updateField('select_caster', $event.target.checked)"
                                />
                                <label
                                    class="custom-control-label"
                                    for="select_caster"
                                >
                                    <div class="switch-content">
                                        <i class="fas fa-toggle-on mr-2"></i>
                                        <div>
                                            <strong>Ativar Rodízio</strong>
                                            <small class="d-block text-muted">
                                                Habilita o sistema de rodízio de veículos
                                            </small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="row"
                    v-if="value.select_caster"
                >
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="inative_caster_ini"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Desativar rodízio a partir de
                            </label>
                            <input
                                id="inative_caster_ini"
                                type="datetime-local"
                                class="form-control"
                                :value="value.inative_caster_ini"
                                @input="updateField('inative_caster_ini', $event.target.value)"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="inative_caster_fin"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Até
                            </label>
                            <input
                                id="inative_caster_fin"
                                type="datetime-local"
                                class="form-control"
                                :value="value.inative_caster_fin"
                                @input="updateField('inative_caster_fin', $event.target.value)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'RotationConfig',
    components: {CardHeader},
    props: {
        value: {type: Object, required: true},
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>

<style scoped>
/* Custom Switch */
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    padding-left: 2rem;
}

.switch-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.switch-content i {
    margin-top: 2px;
    color: #17a2b8;
}
</style>



// WEBPACK FOOTER //
// src/components/Parameters/components/RotationConfig.vue